import React from 'react';
import { Row, Col } from 'antd';

import { OrganizationFormItem } from './OrganizationFormItem';
import { WorkstationFormItem } from './WorkstationFormItem';
import { InitialDateFormItem } from './InitialDateFormItem';
import { FinalDateFormItem } from './FinalDateFormItem';
import { CompanyFormItem } from './CompanyFormItem';
import { SectorFormItem } from './SectorFormItem';
import { LineFormItem } from './LineFormItem';
import { NameFormItem } from './NameFormItem';

export function GeneralInformationForm() {
	return (
		<Row gutter={[16, 16]}>
			<Col span={24}>
				<Row gutter={[16, 16]}>
					<Col sm={6}>
						<OrganizationFormItem />
					</Col>
					<Col sm={6}>
						<CompanyFormItem />
					</Col>
					<Col sm={6}>
						<SectorFormItem />
					</Col>
					<Col sm={6}>
						<LineFormItem />
					</Col>
				</Row>
			</Col>
			<Col span={24}>
				<Row gutter={[16, 16]}>
					<Col sm={6}>
						<WorkstationFormItem />
					</Col>
					<Col sm={6}>
						<NameFormItem />
					</Col>
					<Col sm={6}>
						<InitialDateFormItem />
					</Col>
					<Col sm={6}>
						<FinalDateFormItem />
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
